export const downloadMetamask = () =>
  window.open(`https://metamask.app.link/dapp/${window.location.hostname + window.location.pathname}`);
